import { StyledAuthLayout } from '../../components/Containers';
import { Helmet } from 'react-helmet';
import { EnmonLogo } from '../../components/EnmonLogo';
import { Page as messages } from './messages';
import { useIntl } from '@/components/formatted_message/FormattedMessage';
import { LostDeviceStep } from './enums/lost-device-step';
import { useState } from 'react';
import { Case, ContentSwitch } from '@/components/content_switch';
import { RecoveryMethodContent } from './components/RecoveryMethod';
import { RecoveryCodeContent } from './components/RecoveryCode';
import { MissingCodeContent } from './components/MissingCode';
import { SuccessAdminNotifiedContent } from './components/SuccessAdminNotified';

export const LostDevicePage = () => {
  const intl = useIntl();

  const [step, setStep] = useState<LostDeviceStep>(LostDeviceStep.RecoveryMethod);

  return (
    <StyledAuthLayout>
      <Helmet>
        <title>{intl.formatMessage(messages.helmet)}</title>
      </Helmet>
      <EnmonLogo />
      <ContentSwitch activeId={step}>
        <Case id={LostDeviceStep.RecoveryMethod}>
          <RecoveryMethodContent onStepChange={setStep} />
        </Case>
        <Case id={LostDeviceStep.RecoveryCode}>
          <RecoveryCodeContent onStepChange={setStep} />
        </Case>
        <Case id={LostDeviceStep.MissingCode}>
          <MissingCodeContent onStepChange={setStep} />
        </Case>
        <Case id={LostDeviceStep.SuccessAdminNotified}>
          <SuccessAdminNotifiedContent />
        </Case>
      </ContentSwitch>
    </StyledAuthLayout>
  );
};
